import Player from './player';
import {createOriginalPosition, getSelectablePositionsMap} from 'components/molecules/player-position/helpers';
import {PlayersPoolBuilder} from 'services/players-pool/players-pool-builder';
import Action from 'actions';
import Const from 'constants';

export default class PlayerClassic extends Player {
    getExpandedEntityParams({incomingValues = {}}) {
        const {sportConfig} = incomingValues;
        const expandedPlayer = super.getExpandedEntityParams({incomingValues});

        expandedPlayer.originalPosition = createOriginalPosition(expandedPlayer);
        expandedPlayer.positionName = expandedPlayer.originalPosition.slug;
        expandedPlayer.position = expandedPlayer.originalPosition.numbers;
        expandedPlayer.selectablePositionsMap =
            expandedPlayer.position.length > 1 ? getSelectablePositionsMap(expandedPlayer.position, sportConfig) : {};

        return {
            ...expandedPlayer,
            isFitForLineup(substitutablePlayer) {
                if (substitutablePlayer.positionInLineup === Const.POSITION_UTIL) {
                    return true;
                }

                const substitutePlayerLineupPositions = this.positionName.split('/');
                if (substitutablePlayer.positionInLineup === 'G') {
                    return substitutePlayerLineupPositions.some((position) => inArray(position, ['SG', 'PG']));
                }

                if (substitutablePlayer.positionInLineup === 'F') {
                    return substitutePlayerLineupPositions.some((position) => inArray(position, ['SF', 'PF']));
                }

                return substitutePlayerLineupPositions.some(
                    (position) => substitutablePlayer.positionInLineup === position,
                );
            },
        };
    }

    createPoolsOfPlayers({incomingValues: {players}}) {
        const {playersLock} = Action.getState();

        let builder = new PlayersPoolBuilder(players);

        builder.addTaskOnScenario('doublePosition');
        builder.addTaskOnScenario('position');
        builder.addTaskOnScenario('playerId');
        builder.addTaskOnScenario('teamAndPosition');
        builder.addTaskOnScenario('allowedPositions');
        builder.addTaskOnScenario('externalId');
        builder.addTaskOnProperty('gameInfo');
        builder.addTaskOnProperty('team');
        builder.addTaskOnProperty('positionName');
        builder.addTaskOnProperty('exposureMin', function (player) {
            return !playersLock.isLockedAnywhere(player.getId()) && player.exposureMin > 0;
        });
        builder.addTaskOnProperty('exposureMax', function (player) {
            return !playersLock.isLockedAnywhere(player.getId()) && player.exposureMax < 100;
        });

        return builder.execTasks();
    }

    loadExtraPlayerDataFromStore({incomingValues: {dispatch, data}}) {
        if (data.hasOwnProperty('teamNameStacking')) {
            dispatch(Action.setTeamNameStackingFromStorage(data.teamNameStacking));
        }
    }
}
